import { Injectable } from '@angular/core';
import { collection, deleteDoc, doc, Firestore, getDoc, getDocs, limit, orderBy, query, serverTimestamp, setDoc, updateDoc, where } from '@angular/fire/firestore';
import {UserService} from './user.service'
import { HelperService } from './helper.service';


@Injectable({
  providedIn: 'root'
})
export class ProjectSettingsService {

  constructor(
    private firestore: Firestore,
    private userService:UserService,
    private helperService:HelperService
  ) { 
  }

  public async getProjectSettingsById(settingId:any) {
    let ref = doc(this.firestore,'setting',settingId)  //0df28bbd-07cc-4ee5-8edc-a2874cf25187
    let setting:any = null
    await getDoc(ref).then(doc=>{
      if(doc.exists()){
        setting = doc.data();
        setting.settingId = doc.id;
        // console.log("setting",setting)
      }else{
        // if does not get settingId then call get default settings function for get setting
        setting = this.getDefaultSettings()
      }
    }).catch(err=>{
      setting=null
    })
    return setting;
  }
  // get default settings
  public async getDefaultSettings() {
    let ref = doc(this.firestore,'setting','fkRq9opNjlAyAb6Ng2yX')
    let setting:any = null
    await getDoc(ref).then(doc=>{
      if(doc.exists()){
        setting = doc.data();
        setting.settingId = doc.id;
        // console.log("getDefaultSettings",setting)
      }
    }).catch(err=>{
      setting=null
    })
    return setting;
  }

  public updateProjectSettings(settingId:any, settingsDetails:any) {
    return new Promise((resolve, reject) => {
      const updatedOn = serverTimestamp();
      const updatedBy = this.userService.user.uid;
      settingsDetails.updatedBy = updatedBy;
      settingsDetails.lastUpdateDate = updatedOn;
      let docref =doc(this.firestore,'setting',settingId)
      updateDoc(docref,settingsDetails).then(result => {
        resolve(result)
      }).catch(err => {
        reject(err)
      })
    })
  }

  async createNewSetting(project: any, projectSettings: any, changedProjectSettingsData: any) {
    return new Promise((resolve, reject) => {
      if (!(project && project.quizId))
        reject(null)
      let settings = this.getNewSettings(project, projectSettings, changedProjectSettingsData)
      let settingRef = doc(this.firestore,'setting',settings.settingId)
      setDoc(settingRef,settings).then((result) => {
        resolve(settings)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getNewSettings(project: any, projectSettings: any, changedProjectSettingsData: any) {
    var setting: any = {
      ...projectSettings,
      ...changedProjectSettingsData,
      isDeleted: false,
      settingId: project.quizId,
      creationDate: serverTimestamp(),
      lastUpdateDate: serverTimestamp(),
      createdBy: this.userService.user.uid,
      updatedBy: this.userService.user.uid
    };

    return setting;
  }
  async getWinnerWithQuizId(quizId:any){          ///getting winner list 
    let ref = doc(this.firestore,'winner',quizId)  
    let setting:any = null
    await getDoc(ref).then(doc=>{
      if (doc.exists()){
        setting = doc.data();
      }else{
        console.log("no such doc exists")
      }
    }).catch(err=>{
      setting=null
    })
    return setting;
  }
  ////==========to set a subcollections prize in setting 
  async Prize(data: any, quizId: any) {   ///For settings prize docs
    await setDoc(doc(this.firestore, "setting", quizId, "prize", quizId), data);
  }
  //-----to get value from prize sub collection 
  GetPrize(quizId: any) {   
    return new Promise(async (resolve, reject) => {
      const docRef = doc(this.firestore, "setting", quizId, "prize", quizId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        let data = docSnap.data();
        resolve(data);
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        reject(docSnap)
      }
    })
  }

//=======================general settings upload approved player list=====================================
// create quiz Invitation (approved player)
createQuizInvitation(approvedPlayersArraylist:any,quizLink:any = null){
  if(quizLink){
    console.log(approvedPlayersArraylist)
    return new Promise((resolve, reject) => {
      approvedPlayersArraylist.forEach((ele:any,index:any) => {
        // let _id = this.helperService.uuidv4()
        let __data = {
          ...ele,
          // inviteId:_id
        }
        let queryRef:any =doc(this.firestore,'quizInvitation',__data.inviteId)
        setDoc(queryRef, __data , { merge: true }).then((result) => {
          if(index+1 == approvedPlayersArraylist.length)
            resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    });
  }else{
    return new Promise((resolve, reject) => {
      approvedPlayersArraylist.forEach((ele:any,index:any) => {
        let _id = this.helperService.uuidv4()
        let __data = {
          ...ele,
          inviteId:_id
        }
        let queryRef:any =doc(this.firestore,'quizInvitation',_id)
        setDoc(queryRef, __data , { merge: true }).then((result) => {
          if(index+1 == approvedPlayersArraylist.length)
            resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    });
  }
}
// get quiz Invitation (approved player or username,password )
getQuizInvitationDetailsById(quizId:any,uploadPlayerUsernamePassword:any=null) {
  return new Promise((resolve, reject) => {
    let quizInvitationData:any = [];
    let quizInvitationRef:any = query(collection(this.firestore,'quizInvitation'),where("quizId", "==", quizId),orderBy("createdOn", "asc"),)
    getDocs(quizInvitationRef).then((docs) => {
      docs.forEach((doc) => {
        let _data:any = doc.data()
        // console.log(_data)

        // check for username password registeration
        if(uploadPlayerUsernamePassword && _data.usernamePassword && !_data.isDeleted){
          quizInvitationData.push(_data)

          // check for approved player registration
        }else if(!uploadPlayerUsernamePassword && _data.email && !_data.isDeleted){
          quizInvitationData.push(_data)
        }
        
      });
      resolve(quizInvitationData);
    }).catch((err) => {
      reject(err);
    });
  });
}
//check approved player list
checkQuizInvitationDataAvailableOrNot(quizId:any,uploadPlayerUsernamePassword:any=null) {
  return new Promise((resolve, reject) => {
    let quizInvitationData:any = [];
    let quizInvitationRef:any
    if(uploadPlayerUsernamePassword){
      // check approved player list (username , password)
      quizInvitationRef = query(collection(this.firestore,'quizInvitation'),where("quizId", "==", quizId),where("isDeleted", "==", false),where("usernamePassword", "==", true),limit(1))
    }else{
      // check approved player list (name , email)
      quizInvitationRef = query(collection(this.firestore,'quizInvitation'),where("quizId", "==", quizId),where("isDeleted", "==", false),orderBy("email", "asc"),limit(1))
    } 
    getDocs(quizInvitationRef).then((docs) => {
      docs.forEach((doc) => {
        let _data:any = doc.data()
        // console.log("checkQuizInvitationDataAvailableOrNot",_data)
        quizInvitationData.push(_data)
      });
      resolve(quizInvitationData);
    }).catch((err) => {
      reject(err);
    });
  });
}
//delete approved player list
deleteQuizInvitation(quizId:any,uploadPlayerUsernamePassword:any=null,contestId:any = null){
  return new Promise((resolve, reject) => {
    let quizRef = collection(this.firestore,'quizInvitation')
    let queryRef:any;
    if(contestId == quizId){
      if(uploadPlayerUsernamePassword){
        queryRef = query(quizRef,where('contestId', '==', quizId),where("usernamePassword", "==", true));
      }else{
        queryRef = query(quizRef,where('contestId', '==', quizId),orderBy("email", "asc"));
      }
    }else{
      if(uploadPlayerUsernamePassword){
        queryRef = query(quizRef,where('quizId', '==', quizId),where("usernamePassword", "==", true));
      }else{
        queryRef = query(quizRef,where('quizId', '==', quizId),orderBy("email", "asc"));
      }
    }
    getDocs(queryRef).then((result:any) => {
      if(result){
        result.forEach((element:any) => {
          let _inviteId = element.data().inviteId
          let _data = {
            ...element.data(),
            'isDeleted':true,
            'deletionDateTime':serverTimestamp()
          }
          let quizInvitationRef = doc(this.firestore, 'quizInvitation', _inviteId);
          setDoc(quizInvitationRef, _data, {merge:true})
        })
        resolve(true)
      }else{
        resolve(true)
      }
    }).catch((err:any)=>{
      reject(err)
    })
  })
}
// update setting for live quiz prize
public updateSettings(settingId:any, settingsDetails:any) {
  return new Promise((resolve, reject) => {
    const updatedOn = serverTimestamp();
    const updatedBy = this.userService.user.uid;
    settingsDetails.updatedBy = updatedBy;
    settingsDetails.lastUpdateDate = updatedOn;
    let docref =doc(this.firestore,'setting',settingId)
    updateDoc(docref,settingsDetails).then(result => {
      resolve(true)
    }).catch(err => {
      reject(err)
    })
  })
}

//====================functions for contest creation========================
  checkContestInvitationDataAvailableOrNot(contestId:any,uploadPlayerUsernamePassword:any=null) {
    return new Promise((resolve, reject) => {
      let quizInvitationData:any = [];
      let quizInvitationRef:any
      if(uploadPlayerUsernamePassword){
        // check approved player list (username , password)
        quizInvitationRef = query(collection(this.firestore,'quizInvitation'),where("contestId", "==", contestId),where("isDeleted", "==", false),where("usernamePassword", "==", true),limit(1))
      }else{
        // check approved player list (name , email)
        quizInvitationRef = query(collection(this.firestore,'quizInvitation'),where("contestId", "==", contestId),where("isDeleted", "==", false),orderBy("email", "asc"),limit(1))
      } 
      getDocs(quizInvitationRef).then((docs) => {
        docs.forEach((doc) => {
          let _data:any = doc.data()
          // console.log("checkQuizInvitationDataAvailableOrNot",_data)
          quizInvitationData.push(_data)
        });
        resolve(quizInvitationData);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  getContestInvitationDetailsById(contestId:any,uploadPlayerUsernamePassword:any=null) {
    return new Promise((resolve, reject) => {
      let quizInvitationData:any = [];
      let quizInvitationRef:any = query(collection(this.firestore,'quizInvitation'),where("contestId", "==", contestId),orderBy("createdOn", "asc"),)
      getDocs(quizInvitationRef).then((docs) => {
        docs.forEach((doc) => {
          let _data:any = doc.data()
          // console.log(_data)
  
          // check for username password registeration
          if(uploadPlayerUsernamePassword && _data.usernamePassword && !_data.isDeleted){
            quizInvitationData.push(_data)
  
            // check for approved player registration
          }else if(!uploadPlayerUsernamePassword && _data.email && !_data.isDeleted){
            quizInvitationData.push(_data)
          }
          
        });
        resolve(quizInvitationData);
      }).catch((err) => {
        reject(err);
      });
    });
  }

}
